import { Action, Property } from '@/lib/enums';

export const Budgets = new Set([Property.SALARY, Property.BUDGET]);
export const Metrics = new Set([Property.HOURS, Property.FTE, Property.BUDGET]);
export const ReadActions = new Set([
  Action.READ,
  Action.SUMMARISE,
  Action.BREAKDOWN,
]);
